import { Select, Tag, Tooltip } from "antd";
import { useEffect, useState } from "react";
import useDebounce from "../UseDebounce/useDebounce";

const SelectSearch = ({
  placeholder,
  filters,
  setFilters,
  functionSearch,
  entity,
}) => {
  const [query, setQuery] = useState("");
  const [options, setOptions] = useState([]);
  const debouncedValue = useDebounce(query);

  useEffect(() => {
    if (debouncedValue) {
      functionSearch(debouncedValue, (res) => {
        let option_list = res.map((item) => {
          return {
            ...item,
            value: item.name,
            label: item.name,
          };
        });
        option_list = [
          {
            value: debouncedValue,
            label: debouncedValue,
          },
          ...option_list,
        ];
        setOptions(option_list);
      });
    }
  }, [debouncedValue]);
  const filterOption = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  const tagRenderForSelect = (props) => {
    const { label, value, closable, onClose } = props;
    const onPreventMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    const isLongTag = label.length > 10;
    const tagElem = (
      <Tag
        style={{
          background: "var(--explore-color)",
          color: "white",
          userSelect: "none",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          border: "none",
          height: "28px",
        }}
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
      >
        {isLongTag ? `${label.slice(0, 10)}...` : label}
      </Tag>
    );
    return (
      <>{isLongTag ? <Tooltip title={label}>{tagElem}</Tooltip> : tagElem}</>
    );
  };
  const handleOnSearch = (value) => {
    setQuery(value);
  };
  const handleOnChange = (value) => {
    setFilters({
      ...filters,
      [`${entity}`]: value,
    });
  };
  return (
    <Select
      value={filters[`${entity}`]}
      mode="multiple"
      allowClear
      className="filter-item"
      showSearch
      tagRender={tagRenderForSelect}
      placeholder={placeholder}
      optionFilterProp="children"
      onSearch={handleOnSearch}
      onChange={handleOnChange}
      filterOption={filterOption}
      options={options}
      style={{ width: "100%", marginBottom: "10px", height: "40px" }}
    />
  );
};

export default SelectSearch;
